import {
  requestMyList,
  requestList,
  requestSale,
  requestPriceChange,
  requestAddCart,
  requestDeleteCart,
  requestCartList,
  requestBuyComplete,
  requestBuy,
  requestCheckCart,
  requestPayment,
  requestPurchaseList,
  requestPaymentHistory,
  requestPurchaseDetail,
  requestPaymentList,
  requestPaymentSave,
  requestPaymentDelete,
  requestMarketChoice,
} from '@/api/market';

const state = {
  resultMarketMyList: null,
  resultMarketList: null,
  resultMarketSale: null,
  resultMarketPriceChange: null,
  resultMarketAddCart: null,
  resultMarketCartList: null,
  resultDeleteCart: null,
  resultMarketBuyComplete: null,
  resultMarketBuy: null,
  resultMarketCheckCart: null,
  resultMarketPurchaseList: null,
  resultMarketPurchaseDetail: null,
  resultMarketPayment: null,
  resultMarketPaymentHistory: null,
  resultMarketPaymentList: null,
  resultMarketPaymentSave: null,
  resultMarketPaymentDelete: null,
  resultMarketChoice: null,
  isCartOpen: false,
  selectedMarketId: null,
  // Market MyList用の状態
  myListCardType: null,
  // スナックバー関連の状態
  snackbar: {
    isVisible: false,
    message: '',
    type: 'success',
  },
};

const getters = {
  resultMarketMyList: (state) => state.resultMarketMyList,
  resultMarketList: (state) => state.resultMarketList,
  resultMarketSale: (state) => state.resultMarketSale,
  resultMarketPriceChange: (state) => state.resultMarketPriceChange,
  resultMarketAddCart: (state) => state.resultMarketAddCart,
  resultMarketCartList: (state) => state.resultMarketCartList,
  resultMarketDeleteCart: (state) => state.resultMarketDeleteCart,
  resultMarketBuyComplete: (state) => state.resultMarketBuyComplete,
  resultMarketBuy: (state) => state.resultMarketBuy,
  resultMarketCheckCart: (state) => state.resultMarketCheckCart,
  resultMarketPurchaseList: (state) => state.resultMarketPurchaseList,
  resultMarketPurchaseDetail: (state) => state.resultMarketPurchaseDetail,
  resultMarketPayment: (state) => state.resultMarketPayment,
  resultMarketPaymentHistory: (state) => state.resultMarketPaymentHistory,
  resultMarketPaymentList: (state) => state.resultMarketPaymentList,
  resultMarketPaymentSave: (state) => state.resultMarketPaymentSave,
  resultMarketPaymentDelete: (state) => state.resultMarketPaymentDelete,
  resultMarketChoice: (state) => state.resultMarketChoice,
  isCartOpen: (state) => state.isCartOpen,
  selectedMarketId: (state) => state.selectedMarketId,
  myListCardType: (state) => state.myListCardType,
  snackbar: (state) => state.snackbar,
};

const actions = {
  async my_list({ commit, dispatch, rootGetters }, { pageNumber, postParam }) {
    await dispatch('setIsLoading', true, { root: true });
    const csrfToken = rootGetters.csrf;
    const postParams = postParam;
    const page = pageNumber;
    const result = await requestMyList({ csrfToken, page, postParams }); // APIどれを呼び出すか
    dispatch('setCsrf', { csrfToken: result.data.csrf }, { root: true });
    commit('setRequestMyList', result.data);
    await dispatch('setIsLoading', false, { root: true });
  },
  async list({ commit, dispatch, rootGetters }, { pageNumber, postParam }) {
    await dispatch('setIsLoading', true, { root: true });
    const csrfToken = rootGetters.csrf;
    const postParams = postParam;
    const page = pageNumber;
    const result = await requestList({ csrfToken, page, postParams }); // APIどれを呼び出すか
    dispatch('setCsrf', { csrfToken: result.data.csrf }, { root: true });
    commit('setRequestList', result.data);
    await dispatch('setIsLoading', false, { root: true });
  },
  async sale({ commit, dispatch, rootGetters }, { postParam }) {
    await dispatch('setIsLoading', true, { root: true });
    const csrfToken = rootGetters.csrf;
    const postParams = postParam;
    const result = await requestSale({ csrfToken, postParams });
    dispatch('setCsrf', { csrfToken: result.data.csrf }, { root: true });
    commit('setRequestSale', result.data);
    await dispatch('setIsLoading', false, { root: true });
  },
  async price_change({ commit, dispatch, rootGetters }, { postParam }) {
    await dispatch('setIsLoading', true, { root: true });
    const csrfToken = rootGetters.csrf;
    const postParams = postParam;
    const result = await requestPriceChange({ csrfToken, postParams });
    dispatch('setCsrf', { csrfToken: result.data.csrf }, { root: true });
    commit('setRequestPriceChange', result.data);
    await dispatch('setIsLoading', false, { root: true });
  },
  async add_cart({ commit, dispatch, rootGetters }, { postParams }) {
    await dispatch('setIsLoading', true, { root: true });
    const csrfToken = rootGetters.csrf;
    const result = await requestAddCart({ csrfToken, postParams });
    dispatch('setCsrf', { csrfToken: result.data.csrf }, { root: true });
    commit('setRequestAddCart', result.data);

    // カート追加結果に応じてスナックバーを表示
    if (result.data && result.data.state === 200) {
      // 成功時
      dispatch('showSnackbar', {
        message: postParams.successMessage,
        type: 'success',
      });
    } else if (result.data && result.data.errors) {
      // エラー時
      const errorMessages = [];
      // エラーオブジェクトから全てのエラーメッセージを収集
      Object.values(result.data.errors).forEach((errorArray) => {
        if (Array.isArray(errorArray)) {
          errorMessages.push(...errorArray);
        }
      });

      if (errorMessages.length > 0) {
        dispatch('showSnackbar', {
          message: errorMessages[0], // 最初のエラーメッセージを表示
          type: 'error',
        });
      }
    }

    await dispatch('setIsLoading', false, { root: true });
  },
  async delete_cart({ commit, dispatch, rootGetters }, { postParams }) {
    await dispatch('setIsLoading', true, { root: true });
    const csrfToken = rootGetters.csrf;
    const result = await requestDeleteCart({ csrfToken, postParams });
    dispatch('setCsrf', { csrfToken: result.data.csrf }, { root: true });
    commit('setRequestDeleteCart', result.data);
    await dispatch('setIsLoading', false, { root: true });
  },
  async check_cart({ commit, dispatch, rootGetters }, { postParams }) {
    await dispatch('setIsLoading', true, { root: true });
    const csrfToken = rootGetters.csrf;
    const result = await requestCheckCart({ csrfToken, postParams });
    dispatch('setCsrf', { csrfToken: result.data.csrf }, { root: true });
    commit('setRequestCheckCart', result.data);
    await dispatch('setIsLoading', false, { root: true });
  },
  async buy({ commit, dispatch, rootGetters }, { postParams }) {
    await dispatch('setIsLoading', true, { root: true });
    const csrfToken = rootGetters.csrf;
    const result = await requestBuy({ csrfToken, postParams });
    dispatch('setCsrf', { csrfToken: result.data.csrf }, { root: true });
    commit('setRequestBuy', result.data);
    await dispatch('setIsLoading', false, { root: true });
  },

  async payment({ commit, dispatch, rootGetters }, { postParams }) {
    await dispatch('setIsLoading', true, { root: true });
    const csrfToken = rootGetters.csrf;
    const result = await requestPayment({ csrfToken, postParams });
    dispatch('setCsrf', { csrfToken: result.data.csrf }, { root: true });
    commit('setRequestPayment', result.data);
    await dispatch('setIsLoading', false, { root: true });
  },
  async payment_save({ commit, dispatch, rootGetters }, { postParams }) {
    await dispatch('setIsLoading', true, { root: true });
    const csrfToken = rootGetters.csrf;
    const result = await requestPaymentSave({ csrfToken, postParams });
    dispatch('setCsrf', { csrfToken: result.data.csrf }, { root: true });
    commit('setRequestPaymentSave', result.data);
    await dispatch('setIsLoading', false, { root: true });
  },
  async payment_delete({ commit, dispatch, rootGetters }, { postParams }) {
    await dispatch('setIsLoading', true, { root: true });
    const csrfToken = rootGetters.csrf;
    const result = await requestPaymentDelete({ csrfToken, postParams });
    dispatch('setCsrf', { csrfToken: result.data.csrf }, { root: true });
    commit('setRequestPaymentDelete', result.data);
    await dispatch('setIsLoading', false, { root: true });
  },
  // 以下get
  async buy_complete({ commit, dispatch }) {
    await dispatch('setIsLoading', true, { root: true });
    const result = await requestBuyComplete();
    commit('setRequestBuyComplete', result.data);
    await dispatch('setIsLoading', false, { root: true });
  },
  async historyList({ commit, dispatch }) {
    await dispatch('setIsLoading', true, { root: true });
    const result = await requestCartList();
    commit('setRequestCartList', result.data);
    await dispatch('setIsLoading', false, { root: true });
  },
  async purchase_list({ commit, dispatch }) {
    await dispatch('setIsLoading', true, { root: true });
    const result = await requestPurchaseList();
    commit('setRequestPurchaseList', result.data);
    await dispatch('setIsLoading', false, { root: true });
  },

  async purchase_detail({ commit, dispatch }, { id }) {
    await dispatch('setIsLoading', true, { root: true });
    const result = await requestPurchaseDetail({ id });
    commit('setRequestPurchaseDetail', result.data);
    await dispatch('setIsLoading', false, { root: true });
  },
  async payment_list({ commit, dispatch }) {
    await dispatch('setIsLoading', true, { root: true });
    const result = await requestPaymentList();
    commit('setRequestPaymentList', result.data);
    await dispatch('setIsLoading', false, { root: true });
  },
  async payment_history({ commit, dispatch }) {
    await dispatch('setIsLoading', true, { root: true });
    const result = await requestPaymentHistory();
    commit('setRequestPaymentHistory', result.data);
    await dispatch('setIsLoading', false, { root: true });
  },
  toggleCart({ commit, state }) {
    const next = !state.isCartOpen;
    commit('setIsCartOpen', next);
  },
  async market_choice({ commit, dispatch, rootGetters }, { postParams }) {
    const { isLoading } = rootGetters;
    if (isLoading) {
      return;
    }
    dispatch('setIsLoading', true, { root: true });
    const csrfToken = rootGetters.csrf;
    const result = await requestMarketChoice({ csrfToken, postParams });
    commit('setRequestMarketChoice', result.data);
    dispatch('setCsrf', { csrfToken: result.data.csrf }, { root: true });
    dispatch('setIsLoading', false, { root: true });
  },
  clearMarketChoice({ commit }) {
    commit('setRequestMarketChoice', null);
  },
  async setSelectedMarketId({ commit }, { id }) {
    commit('setSelectedMarketId', id);
  },
  // Market MyList用のアクション
  setMyListCardType({ commit }, cardType) {
    commit('setMyListCardType', cardType);
  },
  clearMyListCardType({ commit }) {
    commit('setMyListCardType', null);
  },
  // スナックバー関連のアクション
  showSnackbar({ commit }, { message, type = 'success' }) {
    commit('setSnackbar', {
      isVisible: true,
      message,
      type,
    });
  },
  hideSnackbar({ commit }) {
    commit('setSnackbar', {
      isVisible: false,
      message: '',
      type: 'success',
    });
  },
};

const mutations = {
  setRequestMyList(state, data) {
    state.resultMarketMyList = data;
  },
  setRequestList(state, data) {
    state.resultMarketList = data;
  },
  setRequestSale(state, data) {
    state.resultMarketSale = data;
  },
  setRequestPriceChange(state, data) {
    state.resultMarketPriceChange = data;
  },
  setRequestAddCart(state, data) {
    state.resultMarketAddCart = data;
  },
  setRequestCartList(state, data) {
    state.resultMarketCartList = data;
  },
  setRequestDeleteCart(state, data) {
    state.resultMarketDeleteCart = data;
  },
  setRequestCheckCart(state, data) {
    state.resultMarketCheckCart = data;
  },
  setRequestBuy(state, data) {
    state.resultMarketBuy = data;
  },
  setRequestBuyComplete(state, data) {
    state.resultMarketBuyComplete = data;
  },
  setRequestPurchaseList(state, data) {
    state.resultMarketPurchaseList = data;
  },
  setRequestPurchaseDetail(state, data) {
    state.resultMarketPurchaseDetail = data;
  },
  setRequestPayment(state, data) {
    state.resultMarketPayment = data;
  },
  setRequestPaymentHistory(state, data) {
    state.resultMarketPaymentHistory = data;
  },
  setRequestPaymentList(state, data) {
    state.resultMarketPaymentList = data;
  },
  setRequestPaymentSave(state, data) {
    state.resultMarketPaymentSave = data;
  },
  setRequestPaymentDelete(state, data) {
    state.resultMarketPaymentDelete = data;
  },
  setRequestMarketChoice(state, data) {
    state.resultMarketChoice = data;
  },
  setIsCartOpen(state, flag) {
    state.isCartOpen = flag;
  },
  setSelectedMarketId(state, id) {
    state.selectedMarketId = id;
  },
  setMyListCardType(state, cardType) {
    state.myListCardType = cardType;
  },
  setSnackbar(state, snackbarData) {
    state.snackbar = { ...snackbarData };
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
